import * as React from 'react';
import Svg, {SvgProps, Rect, Path} from 'react-native-svg';
const SelectedRadioBox = (props: SvgProps) => (
    <Svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
        // @ts-ignore
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
      fill="#0052F6"
    />
  </Svg>
);
export default SelectedRadioBox;
